import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import {
  convertErrors,
  handleBackendError,
  openNotification,
} from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomerRepository from "../../../repositories/customer-repository";
import { IResource } from "../../../utils/interfaces/resource.interface";
import { Customer } from "../../../models/customer";
import { CustomerPayloadType } from "../form/interface";

export const useFormCustomer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<Record<string, any> | null>(null);

  const onDelete = useCallback(
    async (id: number | string) => {
      setDeleteLoading(true);

      return new Promise((resolve, reject) => {
        CustomerRepository.delete(id)
          .then((response: AxiosResponse) => {
            resolve(response);
          })
          .catch((e: AxiosError) => {
            handleBackendError(e, t("notification.error.default"));
            reject(e);
          })
          .finally(() => {
            setDeleteLoading(false);
          });
      });
    },
    [t]
  );

  const onSubmit = useCallback(
    async (data: CustomerPayloadType, id: string | null = null) => {
      setSubmitLoading(true);

      await (id
        ? CustomerRepository.update(id, data)
        : CustomerRepository.create(data)
      )
        .then((response: AxiosResponse<IResource<Customer>>) => {
          navigate("/client");
          openNotification(
            "success",
            t(`notification.success.${id ? "updateItem" : "createItem"}`, {
              item: t("common.text.client"),
            })
          );
        })
        .catch((e: AxiosError) => {
          // handleBackendError(e, t("notification.error.default"));
          openNotification("error", t("notification.error.default"));
          setErrors(convertErrors((e?.response?.data as any).errors));
        })
        .finally(() => {
          setSubmitLoading(false);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, navigate]
  );

  return {
    onSubmit,
    submitLoading,
    deleteLoading,
    onDelete,
    errors,
  };
};
